<template>
  <section id="admin-subscription-test">
    <div v-if="!planSelected">
      <b-card class="text-center">
        <b-card-title>{{ $t("Admin Test Plan (1 TRY / day)") }}</b-card-title>
        <b-card-text>
          Hidden admin-only entry point. Server will reject non-admin users.
          Recurring 1 TRY / day, no trial. Use this to verify the subscription flow end-to-end.
        </b-card-text>
        <b-button variant="warning" @click="beginCheckout">
          {{ $t("Start Admin Test Subscription") }}
        </b-button>
      </b-card>
    </div>
    <div class="checkout-address" v-else>
      <CheckoutAddress :total="priceNcount" plan-key="test" />
    </div>
  </section>
</template>

<script>
import CheckoutAddress from "@/views/pages/pricing/CheckoutAddress.vue";
import { BCard, BCardText, BCardTitle, BButton } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
    BCardTitle,
    BButton,
    CheckoutAddress,
  },
  data() {
    return {
      planSelected: false,
      priceNcount: {
        totalPrice: 0,
        amount: 1,
        subTotal: 0,
        price: 0,
        paidPrice: 0,
        tax: 0,
        totaldiscountRate: 0,
        selectedPlan: { title: "Admin Test Plan (1 TRY / day)", amount: 1 },
      },
    };
  },
  methods: {
    beginCheckout() {
      this.planSelected = true;
    },
  },
};
</script>
